import { render, staticRenderFns } from "./active-notification.vue?vue&type=template&id=af23ac12&"
import script from "./active-notification.vue?vue&type=script&lang=js&"
export * from "./active-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports